import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const ExternalLink = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    strokeAsPrimary: true,
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 24'
    >
      <path
        stroke={primaryColorToUse}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M15.553 3h6m0 0v6m0-6-11 11m8-1v6a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6'
      />
    </svg>
  );
};
